import { Stack, getTheme, mergeStyles } from "@fluentui/react";
import React from "react";
import { LinkWithParams, NavLinkWithParams } from "utils/components/LinkWithParams";
import ButtonLink from "../../controls/ButtonLink";

interface Props {
  to: string;
  external?: boolean;
  asButton?: boolean;
  isNav?: boolean;
  align?: "start" | "center" | "end";
  color?: string;
  target?: string;
}

const HeaderLink: React.FC<Props> = ({
  to,
  external = false,
  asButton = false,
  isNav = false,
  align = "center",
  color = theme.palette.white,
  target = "_self",
  children,
  ...rest
}) => {
  let link;
  const linkStyle = getLinkStyle(color);
  if (external) {
    link = (
      <a href={to} className={linkStyle}>
        {children}
      </a>
    );
  } else if (asButton) {
    link = (
      <ButtonLink to={to} className={buttonStyle}>
        {children}
      </ButtonLink>
    );
  } else if (isNav) {
    link = (
      <NavLinkWithParams to={to} className={linkStyle} target={target}>
        {children}
      </NavLinkWithParams>
    );
  } else {
    link = (
      <LinkWithParams to={to} className={linkStyle}>
        {children}
      </LinkWithParams>
    );
  }

  return (
    <Stack.Item align={align} {...rest}>
      {link}
    </Stack.Item>
  );
};

export default HeaderLink;

const theme = getTheme();

const getLinkStyle = (linkColor: string) => {
  return mergeStyles({
    fontSize: "13px",
    lineHeight: "16px",
    color: linkColor,
    marginTop: "3px",
    textDecoration: "none",
    selectors: {
      "&.active": {
        textDecoration: "underline",
        textDecorationThickness: "2px",
        textUnderlineOffset: "4px",
      },
    },
    ":hover": {
      textDecoration: "underline",
      textDecorationThickness: "2px",
      textUnderlineOffset: "4px",
    },
  });
};

const buttonStyle = mergeStyles({
  textDecoration: "none",
});
